import React from 'react';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import List from '@mui/material/List';

import Typography from '@ts-core/components/Typography';
import { SortableContainer, SortableItem } from '@ts-core/core/components/Sort';

import { PracticeExercise } from '../../types';

import SelectedExerciseListItem from './SelectedExerciseListItem';

export interface SelectedExercisesListProps {
  exercises: PracticeExercise[];

  onRemoveExercise: (exercise: PracticeExercise) => void;
  onSortExercises: (from: number, to: number) => void;
}

const SelectedExercisesList = (props: SelectedExercisesListProps) => {
  const { exercises, onRemoveExercise, onSortExercises } = props;
  const intl = useIntl();

  return (
    <Box height="100%" sx={{ overflowY: 'auto' }}>
      <Typography style={{ marginBottom: 16 }} variant="subtitle2">
        {intl.formatMessage({ id: 'practiceSession.selectedExercises' })}
      </Typography>
      {exercises.length > 0 && (
        <List dense sx={{ py: 0 }}>
          <SortableContainer
            items={exercises}
            onSort={onSortExercises}
            renderOverlay={(exercise) => <SelectedExerciseListItem exercise={exercise} />}
          >
            {exercises.map((e) => (
              <SortableItem key={e.id} id={e.id} minHeight={57}>
                <SelectedExerciseListItem exercise={e} onRemoveExercise={onRemoveExercise} />
              </SortableItem>
            ))}
          </SortableContainer>
        </List>
      )}
    </Box>
  );
};

export default SelectedExercisesList;
